"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _reactModal = _interopRequireDefault(require("react-modal"));

var _config = _interopRequireDefault(require("../config"));

var _listingModule = require("./listingModule");

var _listingsModule = require("../listings/listingsModule");

var _utils = require("../utils");

var AnalyticsModule = _interopRequireWildcard(require("../analytics/modules/AnalyticsModule"));

var _analytics = require("../constants/analytics");

var _this = void 0;

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EnrollModal = function EnrollModal(_ref) {
  var isEnrollModalOpen = _ref.isEnrollModalOpen,
      toggle = _ref.toggle,
      modalNames = _ref.modalNames,
      listingId = _ref.listingId,
      v1ListingId = _ref.v1ListingId,
      checkForConnection = _ref.checkForConnection,
      updateConnectionOnIndex = _ref.updateConnectionOnIndex,
      trackButtonClick = _ref.trackButtonClick,
      userId = _ref.userId,
      companyUUID = _ref.companyUUID,
      listingData = _ref.listingData;

  /*
  * This function is a hack. Code in CTE looks for the existance of
  * this function. If it exists, the styles will work without us needing
  * to hack them in. If removed, all hell breaks loose. For the love
  * of God, do not remove.
  */
  window.otHidePopupDialog = function () {};

  var listingName;

  if (listingData[listingId] !== undefined && listingData[listingId].data !== undefined) {
    listingName = listingData[listingId].data.core ? listingData[listingId].data.core.listingName : listingData[v1ListingId].data.core.listingName;
  } else {
    listingName = listingData[v1ListingId].data.core ? listingData[v1ListingId].data.core.listingName : listingData[listingId].data.core.listingName;
  }

  var toggleThisModal = function toggleThisModal() {
    trackButtonClick({
      elementPath: [[_analytics.listingConst, listingName].join(' '), _analytics.modal.enroll, _analytics.button.x],
      dimensions: {
        listingId: listingId,
        listingName: listingName,
        companyUUID: companyUUID
      }
    });
    toggle(modalNames.enroll);
  };

  if (!(0, _utils.canUseDOM)()) {
    return _react.default.createElement("span", null, "JavaScript is Required to Enroll");
  }

  var style = {
    overlay: {
      zIndex: '100',
      position: 'fixed',
      overflow: 'scroll',
      backgroundColor: 'rgba(0, 0, 0, 0.5)'
    },
    content: {
      position: 'initial',
      width: '90%',
      // ipm uses 835 x 565
      margin: '25px auto',
      overflow: 'scroll'
    }
  };

  var accessIframeEl = function accessIframeEl(selector) {
    var getIframeEl = function getIframeEl() {
      return document.getElementById('autoconnectframe').contentWindow.document;
    };

    var el = getIframeEl().querySelector(selector);

    var listener = function listener(element, cb) {
      element.addEventListener('click', function (event) {
        cb(element, event);
      });
      return {
        addEventListener: listener.bind(_this, element)
      };
    };

    var adjustElement = function adjustElement(element, cb) {
      cb(element);
    };

    return {
      addEventListener: listener.bind(_this, el),
      element: adjustElement.bind(_this, el)
    };
  };

  var keyPressed = function keyPressed(event) {
    if (event.keyCode === 13) {
      toggleThisModal();
    }
  };

  var toggleConnectedStatus = function toggleConnectedStatus() {
    checkForConnection(listingId, v1ListingId);
    updateConnectionOnIndex(listingId, true);
  };

  var counter = 0;

  var addDismissEventListener = function addDismissEventListener() {
    window.setTimeout(function () {
      if (counter < 5) {
        try {
          accessIframeEl('button.ui-button').addEventListener(toggleConnectedStatus).addEventListener(toggleThisModal).addEventListener('keydown', keyPressed);
        } catch (e) {
          addDismissEventListener(counter++);
        }
      }
    }, 500);
  };

  if (isEnrollModalOpen) {
    window.requestAnimationFrame(function () {
      if (document.getElementById('autoconnectframe')) {
        document.getElementById('autoconnectframe').onload = function () {
          accessIframeEl('#enrollbutton').addEventListener(addDismissEventListener);
          accessIframeEl('a.cnqr-connect-appcenter-autoconnect-button-cancel').addEventListener(function () {
            toggleThisModal();
          });
        };
      }
    });
  }

  _reactModal.default.setAppElement('#root');

  return _react.default.createElement("div", {
    className: "modal-container"
  }, _react.default.createElement(_reactModal.default, {
    style: style,
    isOpen: isEnrollModalOpen,
    onRequestClose: toggleThisModal,
    contentLabel: "Enroll in listing modal"
  }, _react.default.createElement("div", {
    className: "row inside-modal"
  }, _react.default.createElement("div", {
    className: "col-xs-10 col-xs-offset-1"
  }, _react.default.createElement("iframe", {
    name: "autoconnect",
    style: {
      border: 'none',
      overflow: 'scroll'
    },
    width: "100%",
    height: "580px",
    id: "autoconnectframe",
    src: "".concat(_config.default.enrollModalBase, "/UI/appcenter/AutoConnect?source=ipm")
  })), _react.default.createElement("div", {
    className: "col-xs-1"
  }, _react.default.createElement("span", {
    className: "close-tandc-modal pull-right",
    onClick: toggleThisModal
  }, "\xD7")))));
};

EnrollModal.propTypes = {
  isEnrollModalOpen: _propTypes.default.bool.isRequired,
  toggle: _propTypes.default.func.isRequired,
  modalNames: _propTypes.default.object.isRequired,
  listingId: _propTypes.default.string.isRequired,
  v1ListingId: _propTypes.default.string.isRequired,
  updateConnectionOnIndex: _propTypes.default.func.isRequired,
  checkForConnection: _propTypes.default.func.isRequired,
  trackButtonClick: _propTypes.default.func,
  userId: _propTypes.default.string,
  companyUUID: _propTypes.default.string,
  listingName: _propTypes.default.string,
  listingData: _propTypes.default.object
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    isEnrollModalOpen: state.listing.isEnrollModalOpen,
    modalNames: state.listing.modalNames,
    userId: state.userPrefs.userId,
    companyUUID: state.userPrefs.companyUUID,
    listingData: state.listing
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps, {
  toggle: _listingModule.toggleModal,
  checkForConnection: _listingModule.checkForConnection,
  updateConnectionOnIndex: _listingsModule.updateConnectedStatus,
  trackButtonClick: AnalyticsModule.buttonClickDispatch
})(EnrollModal);

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./lib/listing/EnrollModal.js
// module id = 269
// module chunks = 0